import { inject, Injectable } from '@angular/core';
import { PaymentApiService } from '@p2p/payment/api';
import { PlatformSettingsApiService } from '@p2p/platform-settings/api';

@Injectable()
export class UserUpsertModalDataFacade {
    private readonly platformSettingsApiService = inject(PlatformSettingsApiService);
    private readonly paymentApiService = inject(PaymentApiService);

    paymentMethodsSettingsLoaded$ = this.platformSettingsApiService.paymentMethodsSettingsLoaded$;
    paymentMethodsSettingsData$ = this.platformSettingsApiService.paymentMethodsSettingsData$;
    commonSettingsLoaded$ = this.platformSettingsApiService.commonSettingsLoaded$;
    commonSettingsData$ = this.platformSettingsApiService.commonSettingsData$;

    paymentMethodsLoaded$ = this.paymentApiService.paymentMethodsLoaded$;
    paymentMethods$ = this.paymentApiService.paymentMethods$;
}
